<template>
	<div class="headerBox disBetween">
		<div class="title">岸鸣充电后台管理系统</div>
		<div class="contBox disBetween">
			<div class="contLeft disBetween">
				<span class="warnIcon"></span>
				<span>{{userObj.warnNum}}</span>
			</div>
			<div class="contLeft disBetween" @click="mallClick">
				<span class="mallIcon" title="岸鸣商城"></span>
			</div>
			<div class="contRight disBetween">
				<span>{{userName}}</span>
				<span class="outIcon" @click="octAct" title="退出"></span>
			</div>
		</div>
	
	</div>
</template>

<script>
	export default {
		name: "",
		components: {},
		props: {
			userObj: {
				type: Object,
				required: true,
				default: {
					warnNum: 0,
					userName: "用户名"
				}
			}

		},
		data() {
			return {
				userName:""
			};
		},
		methods: {
			mallClick(){
				// window.open("https://www.am-mes.cn/mall/#/Login")
				window.open("http://127.0.0.1:8001/mall/#/Login")
			},
			octAct() {
				let that=this
				that.$confirm('是否确认退出?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					localStorage.clear()
					that.$router.push('/login')
				}).catch(() => {

				});
			},
		},

		computed: {},
		created() {
			this.userName=(localStorage.getItem("userName"))
		},
	};
</script>

<style lang="scss" scoped>
	.headerBox {
		height: 100%;
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		user-select: none;
		.title {
			font-size: 24px;
			font-weight: 600;
			color: #fff;
			letter-spacing: 5px;
		}

		.contBox {
			width: 250px;
			height: 100%;
			font-size: 18px;

			.contLeft {
				color: #efa116;

				.warnIcon {
					width: 35px;
					height: 35px;
					background: url('../assets/img/icon/warning.png')no-repeat center;
					background-size: 65%;
				}
				.mallIcon {
					cursor: pointer;
					width: 35px;
					height: 35px;
					transition: 0.1s;
					background: url('../assets/img/icon/mall.png')no-repeat center;
					background-size: 70%;
				}
			}
			.contLeft:hover{
				.mallIcon {
					width: 35px;
					height: 35px;
					border-radius: 50%;
					background:#fff url('../assets/img/icon/mallA.png')no-repeat center;
					background-size: 72%;
				}
			}
			.contRight {
				color: #fff;
				font-size: 14px;
				letter-spacing: 2px;

				.outIcon {
					cursor: pointer;
					width: 35px;
					height: 35px;
					background: url('../assets/img/icon/out.png')no-repeat center;
					background-size: 55%;
					margin-left: 6px;
				}
			}
			// .contRight:hover{
			// 	.outIcon {
			// 		width: 35px;
			// 		height: 35px;
			// 		border-radius: 50%;
			// 		background:#fff url('../assets/img/icon/outA.png')no-repeat center;
			// 		background-size: 55%;
			// 	}
			// }
		}
	}
</style>